/*eslint backbone/no-constructor:0 */
define('glu/grid/column/columnHeaderResizer',['require','../../itemView','../../$document','../../$','../../util'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        $document = require('../../$document'),
        $ = require('../../$'),
        util = require('../../util');

    return ItemView.extend({
        template: function() {
            return '&nbsp;';
        },

        className: function() {
            var disabledClass = (!this.options.data.get('resizable')) ? ' disabled' : '';
            return 'grid-column-resize-marker' + disabledClass;
        },

        events: {
            'mousedown': 'handleDragStart',
            'touchstart': 'handleDragStart'
        },

        resizeActiveClassName: 'grid-column-resize-active',
        dragEnabled: false,
        minWidth: 67,

        attributes: {
            'role': 'presentation'
        },

        whitelistOpts: ['alsoResize', 'animate', 'animateDuration',
            'animateEasing', 'aspectRatio', 'autoHide', 'cancel', 'containment',
            'delay', 'disabled', 'distance', 'ghost', 'grid', 'handles', 'helper',
            'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'destroy', 'disable',
            'enable', 'instance', 'option', 'widget', 'create', 'resize', 'start', 'stop'
        ],

        ui: {
            resizeMarker: '.grid-column-resize-marker'
        },

        constructor: function(opts) {
            ItemView.prototype.constructor.call(this, opts);
            this.th = opts.th;
            this.$th = $(this.th); // eslint-disable-line backbone/no-native-jquery
            this.dragEnabled = false;
            this.data = opts.data;

            if (this.data.has('width')) {
                this.originalWidth = this.data.get('width');
                this.$th.css({
                    width: this.originalWidth,
                    maxWidth: this.originalWidth,
                    minWidth: this.originalWidth
                });
            }
        },

        disableTextSelection: function() {
            this.$th.parents('table').find('th, td').attr('unselectable', 'on')
                .css('user-select', 'none')
                .on('selectstart', false);
        },

        enableTextSelection: function() {
            this.$th.parents('table').find('th, td').removeAttr('unselectable')
                .css('user-select', 'text')
                .off('selectstart');
        },

        handleDragStart: function(e) {
            // Only allow drag start on left mouse button (1)
            if (e.which !== 1) {
                return;
            }

            this.disableTextSelection();

            this.$th.addClass('grid-resizing');

            this.originalX = e.pageX;
            this.$body = $document.find('body');
            this.$table = this.$th.parents('table'); //default assumption
            this.$infoContainer = this.$table.siblings('[data-hook="infoContainer"]');
            this.$body.on('mouseup touchend touchleave touchcancel', util.bind(this.handleDragEnd, this));
            this.$body.on('mousemove touchmove', util.bind(this.handleDragMove, this));
            this.originalWidth = this.$th.width();
            this.tableWidth = parseFloat(this.$table.width() - this.originalWidth);
            this.dragEnabled = true; // necessary if there is padding around the outer relative DOM element
            this.$table.addClass(this.resizeActiveClassName);
            return e;
        },

        handleDragMove: function(e) {
            if (this.dragEnabled) {
                this.deltaX = e.pageX - this.originalX;
                var width = parseFloat(this.originalWidth) + this.deltaX;
                if (width >= this.minWidth) {
                    this.$th.css({
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    });
                }
                // set the table's width on `the fly` so grid won't jump
                this.$table.width(this.tableWidth + width);

                // set the width for info container and minus 20 for padding
                this.$infoContainer.width(this.tableWidth + width - 20);
            }
        },

        handleDragEnd: function(e) {
            this.enableTextSelection();

            this.$th.removeClass('grid-resizing');

            this.dragEnabled = false;
            if (util.isObject(this.$table) && !util.isNull(this.$table)) {
                this.$table.removeClass(this.resizeActiveClassName);
                this.$body.off('mouseup touchend touchleave touchcancel mousemove touchmove');
                this.$table = null;
            }
            this.data.set({
                width: this.$th.width()
            });
            this.options.grid.trigger('grid:columnResizeComplete');

            return e;
        },

        remove: function() {
            ItemView.prototype.remove.call(this, arguments);

            if (util.isObject(this.$table) && !util.isNull(this.$table)) {
                this.$table.removeClass(this.resizeActiveClassName);
                this.$body.off('mouseup touchend touchleave touchcancel mousemove touchmove');
            }
        }
    });
});

